import { debounce as _debounce } from 'underscore';
import { gsap } from 'gsap';

export default class{

    constructor(options) {
        this.defaults = {
        	$el: false,

        	margin: 40
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = 'ticker';

		this.$el = this.options.$el;


		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	let  	content = this.$el.html(), 
    			inner = '<div class="inner">';
    			inner += '<div class="content">' + content + '</div><div class="content" style="margin-left:' +  this.options.margin + 'px;">' + content + '</div>';
    			inner += '</div>';

    	this.content = content;
    	this.$el.html( inner );
    	this.$inner = this.$el.find( '.inner' );

    	this.addEvents( true );
    	this.update();
    }

    addEvents(b){
    	this.debounceResize(b);
    }

    debounceResize(b){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 17 );
			$(window).on( 'resize', this._debResize );
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				$(window).off( 'resize', this._debResize );
			}        
		}
    }

    onResize(){
    	this.activate( false );
    	this.update();

    	const w = this.$el.width(), wc = this.$inner.find('.content').width();
    	if ( wc > w && this.isPlaying ){
    		this.activate( true );
    	}
    }

    update(){
    	const w = this.$el.width(), wc = this.$inner.find('.content').width(), $last = this.$inner.find('.content:eq(1)');
 		this.x = 0;
 		gsap.set( this.$inner, {x:this.x} );
 		if ( wc > w ){
 			this.$inner.width( 2*wc + this.options.margin );
 			$last.show(0);
 		}
 		else{
 			$last.hide(0);
 		}
    }

    activate(b){
    	if (b){

    	}
    	else{

    	}
    	this.activateTick(b)
    }

    activateTick(b){
		this.active = false;
		if ( this.id_ticker ){
			cancelAnimationFrame( this.id_ticker );
		}
		if ( b ){

			const w = this.$el.width(), wc = this.$inner.find('.content').width();
			if ( wc <= w ){
				return;
			}


			this.active = true;
			this.tick();
		}
    }

    tick(){
		this.translate();
		if ( this.active ){
			this.id_ticker = requestAnimationFrame( () => this.tick() );
		}
	}

	translate(){
		const w = - ( this.$inner.find('.content').width() + this.options.margin );
		this.x -= 1;
		//console.log( this.$inner.width() - this.$el.width() );
		if ( this.x <= w ){
			this.x = 0;
		}
		gsap.set( this.$inner, {x:this.x} );
	}

	play(b){
		this.activateTick(b);
		this.isPlaying = b
	}


    destroy(){
    	this.addEvents( false );
    	this.activate( false );
    	this.$el.html( this.content );
    }

}